import React from 'react'

import TextInput from '../TextInput'
import SearchIcon from '../../../../assets/icons/mag-glass.svg?react'

type Props = {
  onSubmit: (value: string) => void,
  defaultValue?: string,
  bg?: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  placeholder?: string
  showResetIcon?: boolean
}
const SearchInput:React.FC<Props> = ({ onSubmit, defaultValue, bg = 'bg-gray-300', onChange, placeholder, showResetIcon }) => {
  const [value, setValue] = React.useState<string>(defaultValue || '')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    if(onChange) {
      onChange(e)
    }
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit(value)
  }

  return (
    <form onSubmit={handleSubmit} className='flex-1 w-full'>
      <TextInput
        icon={<SearchIcon />}
        className={`${bg} w-full`}
        placeholder={placeholder}
        type='text'
        value={value}
        onChange={handleChange}
        showResetIcon={showResetIcon}
      />
    </form>
  )
}

export default SearchInput
